export const DEFAULT_APP_STORAGE_NAME = 'reffie';
